export default __webpack_public_path__ + "static/seat~zTknTpRL-159bc1391dca92d3514ec2c6b10f4f1b.png";